var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoExecutionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "173px",
    height: "134px",
    viewBox: "0 0 173 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0892400023 0.0455629753 93.5149725 0.0455629753 93.5149725 36.9233803 0.0892400023 36.9233803"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "projects-empty",
    transform: "translate(-623.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-empty",
    transform: "translate(623.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0500734,24.4146476 L26.5842612,24.4146476 C24.577809,24.4146476 22.9726473,26.0618044 22.9726473,28.0205855 C22.9726473,30.0238843 24.6223968,31.6265233 26.5842612,31.6265233 L32.5144421,31.6265233 C34.5208943,31.6265233 36.126056,33.2736801 36.126056,35.2324611 C36.126056,37.2357599 34.4763064,38.838399 32.5144421,38.838399 L4.24576027,38.838399 C2.23930809,38.838399 0.634146341,40.4855558 0.634146341,42.4443368 C0.634146341,44.4031178 2.28389591,46.0502746 4.24576027,46.0502746 L18.3355133,46.0502746 C20.3419655,46.0502746 21.9471273,47.6974314 21.9471273,49.6562125 C21.9471273,51.6595113 20.2973777,53.2621503 18.3355133,53.2621503 L18.0233986,53.2621503 C16.0169464,53.2621503 14.4117846,54.9093071 14.4117846,56.8680881 C14.4117846,58.8713869 16.0615342,60.474026 18.0233986,60.474026 L47.0500734,60.474026 L66.1336631,60.474026 L87.2682927,60.474026 L87.2682927,24.3701299 L74.6945257,24.3701299 L47.0500734,24.4146476 Z",
    id: "Fill-1",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7071199,65.8896104 L64.7071199,75.5621442 C64.7071199,75.5621442 64.8387,81.2337662 58.3035577,81.2337662 C51.7684155,81.2337662 52.0754356,73.7155695 52.0754356,73.7155695",
    id: "Stroke-3",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3414634,65.8896104 L77.3414634,98.3831169",
    id: "Stroke-5",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.146539,65.8896104 L116.146539,75.5621442 C116.146539,75.5621442 116.014959,81.2337662 122.550101,81.2337662 C129.085243,81.2337662 128.778223,73.7155695 128.778223,73.7155695",
    id: "Stroke-7",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.512195,65.8896104 L103.512195,98.3831169",
    id: "Stroke-9",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9756098,65.8896104 L89.9756098,101.993506",
    id: "Stroke-11",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(79.146341, 14.441558)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6469649,36.8779083 L40.2561472,36.8779083 L89.9081446,36.8779083 C91.9120368,36.8779083 93.5151506,35.1954431 93.5151506,33.1946737 C93.5151506,31.1484323 91.8670606,29.5114392 89.9081446,29.5114392 L74.3223158,29.5114392 C72.3184235,29.5114392 70.7148644,27.8289741 70.7148644,25.8282047 C70.7148644,23.7819633 72.3629545,22.1449702 74.3223158,22.1449702 L83.005849,22.1449702 C85.0097412,22.1449702 86.6128551,20.462505 86.6128551,18.4617356 C86.6128551,16.4609663 84.964765,14.7785011 83.005849,14.7785011 L38.2072787,14.7785011 C36.2033865,14.7785011 34.600718,13.0960359 34.600718,11.0952666 C34.600718,9.04902516 36.2483627,7.41203204 38.2072787,7.41203204 L59.2263274,7.41203204 C61.2302197,7.41203204 62.8328882,5.72956688 62.8328882,3.72879751 C62.8328882,1.6825561 61.1856887,0.0455629753 59.2263274,0.0455629753 L40.2561472,0.0455629753 L21.1964599,0.0455629753 L0.0892400023,0.0455629753 L0.0892400023,36.9233803 L12.6469649,36.9233803 L12.6469649,36.8779083 Z",
    id: "Fill-13",
    fill: "#F2F2F2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.4567375,24.2824271 C56.4567375,24.2824271 61.8484632,0.635828399 84.9749562,0.00404904351 C84.9749562,0.00404904351 105.160508,-0.763111602 112.200943,18.8220484 C112.200943,18.8220484 138.580295,14.6703555 140.496363,41.3855968 C140.496363,41.3855968 141.788595,63.0917304 121.023767,65.8896104 L58.6401636,65.8896104 C58.6401636,65.8896104 38.0981342,65.6639749 38.5437313,44.6347478 C38.5437313,44.6347478 37.652537,29.336662 56.4567375,24.2824271",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4567375,24.2824271 C56.4567375,24.2824271 61.8484632,0.635828399 84.9749562,0.00404904351 C84.9749562,0.00404904351 105.160508,-0.763111602 112.200943,18.8220484 C112.200943,18.8220484 138.580295,14.6703555 140.496363,41.3855968 C140.496363,41.3855968 141.788595,63.0917304 121.023767,65.8896104 L58.6401636,65.8896104 C58.6401636,65.8896104 38.0981342,65.6639749 38.5437313,44.6347478 C38.5437313,44.6347478 37.652537,29.336662 56.4567375,24.2824271 Z",
    id: "Stroke-18",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(45.756098, 37.909091)",
    stroke: "#304365",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.673
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5618971,0.0315217932 L5.5618971,32.2598239",
    id: "Stroke-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4046367,0.0315217932 C10.4046367,0.0315217932 13.5255134,10.3770776 5.5618971,10.3770776 C-2.40171921,10.3770776 0.66534923,0.0315217932 0.66534923,0.0315217932",
    id: "Stroke-24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.749584,19.5605792 C105.055313,0.0561795668 85.4634146,0.908095872 85.4634146,0.908095872 C85.4634146,0.908095872 107.733022,4.27092339 109.6516,26.1517211 C109.6516,26.1517211 134.52033,26.1517211 134.52033,44.24331 C134.52033,58.3772307 119.979736,62.8255983 104.716352,64.7536195 L121.184704,64.7536195 C140.723495,62.1433808 139.59775,40.8584868 139.59775,40.8584868 C138.615924,15.1664846 111.749584,19.5605792 111.749584,19.5605792 Z",
    id: "Fill-30",
    fill: "#9ECDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.798587,45.5561783 C132.798587,45.5561783 135.36663,54.1558442 128.793502,54.1558442 C122.219938,54.1558442 124.744883,45.5561783 124.744883,45.5561783 C124.744883,45.5561783 125.615554,40.6168831 128.793502,40.6168831 C131.97145,40.6168831 132.798587,45.5561783 132.798587,45.5561783",
    id: "Fill-34",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(123.365854, 34.298701)",
    stroke: "#304365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82796055,17.5640576 L5.82796055,35.8712286",
    id: "Stroke-32",
    strokeWidth: 2.1384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7784242,6.89720566 C10.7784242,6.89720566 13.952571,17.4184205 5.82806816,17.4184205 C-2.2969728,17.4184205 0.82390386,6.89720566 0.82390386,6.89720566 C0.82390386,6.89720566 1.90006823,0.854251473 5.82806816,0.854251473 C9.7560681,0.854251473 10.7784242,6.89720566 10.7784242,6.89720566 Z",
    id: "Stroke-36",
    strokeWidth: 2.1384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6982032,5.38657502 C4.6982032,5.38657502 3.56769253,7.81454768 3.62203883,11.3755743",
    id: "Stroke-38",
    strokeWidth: 1.6038
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10598994,13.8036009 L4.37503104,14.2891954",
    id: "Stroke-40",
    strokeWidth: 1.6038
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(69.219512, 10.831169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1122829,4.51298701e-05 C16.1122829,4.51298701e-05 12.1610634,11.4179023 0.351307317,11.4179023",
    id: "Fill-44",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1122829,4.51298701e-05 C16.1122829,4.51298701e-05 12.1610634,11.4179023 0.351307317,11.4179023",
    id: "Stroke-46",
    stroke: "#0088FF",
    strokeWidth: 2.2275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.5169542,13.538961 L84.3848899,13.538961 C82.800119,16.2247387 79.5865556,20.2313906 74.0838786,21.6403231 C73.8637716,22.5209059 73.7317073,23.4014888 73.7317073,24.3701299 C73.7317073,30.3580931 78.5740631,35.2012987 84.5609756,35.2012987 C90.5478882,35.2012987 95.3902439,30.3580931 95.3902439,24.3701299 C95.3462225,18.3821666 90.5038667,13.538961 84.5169542,13.538961",
    id: "Fill-48",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2682927,17.1493506 C89.7601294,17.1493506 91.7804878,19.1700636 91.7804878,21.6623377 C91.7804878,24.1546117 89.7601294,26.1753247 87.2682927,26.1753247 C84.7759955,26.1753247 82.7560976,24.1546117 82.7560976,21.6623377 C82.7560976,19.1700636 84.7759955,17.1493506 87.2682927,17.1493506",
    id: "Fill-50",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,26.1753247 C82.2448522,26.1753247 83.6585366,27.5897358 83.6585366,29.3344156 C83.6585366,31.0790953 82.2448522,32.4935065 80.5,32.4935065 C78.7556264,32.4935065 77.3414634,31.0790953 77.3414634,29.3344156 C77.3414634,27.5897358 78.7556264,26.1753247 80.5,26.1753247",
    id: "Fill-52",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(24.000000, 83.941558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.905135,22.0672472 C130.787295,40.9839192 102.333182,48 65.9535837,48 C29.5719524,48 0,37.7285959 0,22.0672472 C0,9.86359881 29.5719524,0 65.9535837,0 C102.333182,0 132.616488,9.96631285 131.905135,22.0672472",
    id: "Fill-20",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9592169,0 C102.387202,0 131.917417,9.94902596 131.917417,22.2217102 C131.917417,34.4964426 102.387202,44.4444444 65.9592169,44.4444444 C29.5312321,44.4444444 0,34.4964426 0,22.2217102 C0,9.94902596 29.5312321,0 65.9592169,0",
    id: "Fill-26",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2022022,32 C40.2475445,29.8505051 24.2297297,26.9845118 24.2297297,20.7407407 C24.2297297,18.6936027 26.37224,16.7488215 30.147139,15.1111111 C30.147139,15.213468 20.8629279,25.4491582 68.2022022,32",
    id: "Fill-28",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5555556,-8.52651283e-14 C63.5555556,-8.52651283e-14 145.202668,13.0025895 86.8285024,43.2182164 C96.8296706,41.7939107 131.84445,37.6355354 131.84445,21.5335267 C131.84445,9.51654115 101.604184,-8.52651283e-14 63.5555556,-8.52651283e-14 Z",
    id: "Fill-42",
    fill: "#ECECEC"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoExecutionHistory);
export default __webpack_public_path__ + "static/media/no-execution-history.39babc35adb0ccc76d34626c016b4ec9.svg";
export { ForwardRef as ReactComponent };